// @flow

require('./js/extenders');

export interface JSableInterface {
	toJS(): Object;
	fromJS(Object): void;
}

export { JSableMixin, JSable } from './js/jsable';
export { JSableOmitPrivateMixin, JSableOmitPrivate } from './js/jsable-omit-private';
export {
	createJSableEntityListMapExtender,
	createJSableObjExtender,
	createJSableNullableObjExtender,
	createJSableMomentFromISOMapExtender,
	createIdentifiedEntityListMapExtender,
	createJSableMultiTypeListMapExtender,
} from './js/helpers';
